export default "__VITE_ASSET__CSJ4v5sN__"